export default __webpack_public_path__ + "static/media/receiver-view.5875ec9c.svg";